import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Wrapper } from "..";
import NumberComplaint from "./content/number-complaint";
import { StatusBox } from "./content/status-box";
import VolumeComplaint from "./content/volume-complaint";

const Complaint = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Row gutter={[14, 14]}>
        <StatusBox />
        <Col span={24}>
          <VolumeComplaint />
        </Col>
        <Col span={24}>
          <NumberComplaint />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default Complaint;
